import React from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { isArray, map } from 'lodash';

import { translate } from 'react-i18next';
import { formatVolume10 } from '../../utils';
class HistoryChart extends React.Component {
  constructor(props) {
    super(props);

    this.chartComponent = React.createRef();

    this.state = {
      chartOptions: {},
    };
  }

  _mapDataToState = (stockHis) => {
    const volSeries = map(stockHis, 'vol');
    const priceSeries = map(stockHis, 'close');
    const avgPriceSeries = map(stockHis, 'open');
    const dateSeries = map(stockHis, 'time');

    const { t } = this.props;

    const chartOptions = {
      title: {
        text: ' ',
      },
      subtitle: {
        text: ' ',
      },
      xAxis: [
        {
          visible: false,
          categories: dateSeries,
          crosshair: true,
        },
      ],
      yAxis: [
        {
          // Primary yAxis
          labels: {
            format: '{value}',
            style: {
              color: '#563ff4',
            },
          },
          title: {
            text: t('txt-price'),
            style: {
              color: '#563ff4',
            },
          },
        },
        {
          // Secondary yAxis
          title: {
            text: t('txt-vol'),
            style: {
              color: '#26abd8',
            },
          },
          labels: {
            formatter: function () {
              return formatVolume10(this.value);
            },
            // format: '{value}',
            style: {
              color: '#26abd8',
            },
          },
          opposite: true,
        },
      ],
      tooltip: {
        shared: true,
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: ' ',
          type: 'column',
          color: '#26abd8',
          yAxis: 1,
          data: volSeries,
          tooltip: {
            valuePrefix: `${t('txt-vol')} `,
          },
        },
        {
          name: ' ',
          type: 'spline',
          color: '#563ff4',
          data: priceSeries,
          tooltip: {
            valuePrefix: `${t('txt-price-close')} `,
          },
        },
        {
          name: ' ',
          type: 'spline',
          color: '#b99d00',
          data: avgPriceSeries,
          tooltip: {
            valuePrefix: `${t('txt-price-ave')} `,
          },
        },
      ],
    };
    this.setState({ chartOptions });
  };

  componentDidUpdate(preProps) {
    const { stockHis } = this.props;

    if (stockHis && stockHis !== preProps.stockHis && isArray(stockHis)) {
      // console.log(typeof(stockHis))
      const _stockHis = stockHis.reverse();
      this._mapDataToState(_stockHis);
    }
  }

  render() {
    return (
      <HighchartsReact
        ref={this.chartComponent}
        highcharts={Highcharts}
        options={this.state.chartOptions}
        containerProps={{ style: { height: '200px' } }}
      />
    );
  }
}

export default translate('translations')(HistoryChart);
